import { render, staticRenderFns } from "./DaftarUnit.vue?vue&type=template&id=745575a6&scoped=true"
import script from "./DaftarUnit.vue?vue&type=script&lang=js"
export * from "./DaftarUnit.vue?vue&type=script&lang=js"
import style0 from "./DaftarUnit.vue?vue&type=style&index=0&id=745575a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745575a6",
  null
  
)

export default component.exports